angular.module('b2bLoginApp.routers').config(["$routeProvider", "$locationProvider", function($routeProvider, $locationProvider) {
    // Routing
    $locationProvider.html5Mode(true);
    $routeProvider.
        when('/targeting', {
            controller: 'AreasController',
            templateUrl: '/account/areas/areas.html'
        }).
        when('/public-profile', {
            controller: 'CompanyProfilePublicController',
            templateUrl: '/account/company-profile-public/company-profile.html'
        }).
        when('/contact', {
            controller: 'ContactController',
            templateUrl: '/account/contact/contact.html'
        }).
        when('/articles/:name*', {
            templateUrl: function(template){
                return '/account/articles/' + template.name + '.html';
            }
        }).
        when('/referral', {
            controller: 'ReferralController',
            templateUrl: '/account/referral/referral.html'
        }).
        when('/prices', {
            controller: 'PricingController',
            templateUrl: '/account/pricing/pricing.html'
        }).
        otherwise({
            //controller: 'NotFoundController',
            templateUrl: '/error/404.html'
        })
    ;
}]);
